import { type Address, getAddress } from "viem";

export const addressStorage = {
  getItem: (key: string): Address | undefined => {
    const value = localStorage.getItem(key);
    if (!value) return undefined;

    try {
      return getAddress(value);
    } catch {
      return undefined;
    }
  },
  setItem: (key: string, value?: Address) => {
    if (!value) return;

    try {
      const checksummedAddress = getAddress(value);
      localStorage.setItem(key, checksummedAddress);
    } catch {
      // Invalid address, don't store it
    }
  },
  removeItem: (key: string) => {
    localStorage.removeItem(key);
  },
};
